import { h, Component } from 'preact';
import PowsterLogo from 'components/bolt/icons/powsterLogo';

import s from 'components/footer/footer.scss';

export default class Footer extends Component {
	render() {
		return (
			<footer class={s.root}>
				<small class={s.poweredBy}>powered by</small>
				<PowsterLogo class={s.logo} />
			</footer>
		);
	}
}